import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@saucelabs/sl-component-overlay';
import Button from '@saucelabs/sl-component-buttons';
import modalConnect from '@saucelabs/sl-container-modal';

import AddGroupForm from './AddGroupForm';

const name = 'addGroup';
const addGroupFormHandler = { submit: null };

const AddGroupModal = ({ createGroup, limits, onHide, show }) => (
  <Modal
    onHide={onHide}
    show={show}
  >
    <Modal.Header>
      <Modal.Title>Create new line of business</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <AddGroupForm
        createGroup={createGroup}
        formHandler={addGroupFormHandler}
        limits={limits}
        onCreateGroupSuccess={onHide}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button
        category="default"
        material
        onClick={onHide}
        size="sm"
      >
        Cancel
      </Button>
      <Button
        category="action"
        material
        onClick={() => addGroupFormHandler.submit()}
        size="sm"
      >
        Add Line of Business
      </Button>
    </Modal.Footer>
  </Modal>
);

AddGroupModal.propTypes = {
  createGroup: PropTypes.func.isRequired,
  limits: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default modalConnect(name, AddGroupModal);
export { AddGroupModal, name };
